export const PAYMENT_RETURN_WORKSPACE_ID_KEY = 'bustly_payment_return_workspace_id';

export const writePaymentReturnWorkspaceId = (workspaceId?: string | null) => {
    if (typeof window === 'undefined' || !workspaceId) return;
    window.sessionStorage.setItem(PAYMENT_RETURN_WORKSPACE_ID_KEY, workspaceId);
};

export const readPaymentReturnWorkspaceId = (): string | null => {
    if (typeof window === 'undefined') return null;
    return window.sessionStorage.getItem(PAYMENT_RETURN_WORKSPACE_ID_KEY);
};

export const clearPaymentReturnWorkspaceId = () => {
    if (typeof window === 'undefined') return;
    window.sessionStorage.removeItem(PAYMENT_RETURN_WORKSPACE_ID_KEY);
};
